<template>
<router-view />
</template>

<script>
export default {
  name: 'OperationsAlarm',
  routeInfo: {
    label: '报警统计查询',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/08Operations/06Alarm/index.vue